module.exports = __webpack_public_path__ + "static/4-8bbfd7123485cfe7ef1971ee1c20bd37.jpg";